// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3y3b0","flexWrapper":"_3vhvu"};